module.exports = __webpack_public_path__ + "static/new_editor_1-5f9c65159f03b70d4ff04b73731b149e.png";